import { useEffect, useMemo, useState } from "react";
import CustomDataTable from "../../../components/CustomDataTable";
import FormModal from "./FormModal";
import { TemplatesService } from "../../../services/TemplatesService";
import { AlertService } from "../../../services/Alert";
import { API_ENDPOINT } from "../../../constants";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import { useTranslation } from "react-i18next";
import useRequest from "../../../hooks/useRequest";
function TemplatesPartial() {

    const { t } = useTranslation();
    const {call, isRequesting} = useRequest();
    const { account } = useCurrentAccount();
    
    const [showModal, setShowModal] = useState(false);
    const [templates, setTemplates] = useState([]);
    const [currentTemplate, setCurrentTemplate] = useState();
    

    const getFormat = (type) => {
        switch (type) {
            case 'TXT':
                return 'Texto'
            case 'IMG':
                return 'Imagen'
            case 'FILE':
                return 'Archivo'
        
            default:
                return type
        }
    }
    
    const columns = useMemo(() => [
        {
            name: t("config.templates.name"),
            sortable: true,
            selector: row => {

                const getImage = (type) => {
                    switch (type) {
                        case 'TXT':
                            return '/assets/svg/brands/icon-text.svg'
                        case 'IMG':
                            return '/assets/svg/brands/placeholder-img-format.svg'
                        case 'FILE':
                            return '/assets/svg/brands/icon-file.svg'
                        case 'pdf':
                            return '/assets/svg/brands/pdf-icon.svg'
                        case 'word':
                            return '/assets/svg/brands/word-icon.svg'
                        case 'excel':
                            return '/assets/svg/brands/excel-icon.svg'
                        
                    
                        default:
                            return '/assets/svg/brands/pdf-icon.svg'
                    }
                }

                return (
                    <div className="d-flex align-items-center">
                        <img src={getImage(row.type)} className="type-template" /> 
                        <div className="">
                            {
                                row.type === 'TXT' ? (
                                    <p className="m-0">{row.title}</p>
                                ): (
                                    <p className="m-0"><a href={ API_ENDPOINT.CORE+'accounts/file?id='+row.name } target="_blank" rel="noreferrer" className="text-info link-underline">{row.title} <i className="bi-box-arrow-up-right"></i></a></p>
                                )
                            }
                            <p className="m-0 small">{getFormat(row.type)}</p>
                        </div>
                    </div>
                )
            },
            with: 30
        },    
        {
            name: t("config.templates.status"),
            sortable: true,
            cell: (row) => {

                if(row.status === 1) {
                    return (
                        <span className="badge bg-soft-info text-info">
                            <span className="legend-indicator bg-info"></span> {t("config.templates.active")}
                        </span>
                    )
                }

                if(row.status === 2) {
                    return (
                        <span className="badge bg-soft-danger text-danger">
                            <span className="legend-indicator bg-danger"></span> {t("config.templates.inactive")}
                        </span>
                    )
                }
            }
        },      
        {
            name: t("config.templates.subaccount"),
            sortable: true,
            selector: row => {
                return row.sub_account || '-'

            },
        },        
        
        {
            name: t("config.templates.actions"),
            sortable: false,
            center: true,
            with: 20,
            cell: (row) => {
                return (
                    <div className="btn-group" role="group">
                        <button className="btn btn-white btn-sm" onClick={() => editTemplate(row)}>
                        {t("config.templates.edit")}
                        </button>

                        <div className="btn-group">
                            <button type="button" className="btn btn-white btn-icon btn-sm dropdown-toggle dropdown-toggle-empty" data-bs-toggle="dropdown" aria-expanded="false"></button>

                            <div className="dropdown-menu dropdown-menu-end mt-1" >
                                <button className="dropdown-item" onClick={() => changeStatus(row.id, row.status, row.type)}>
                                    { row.status === 1 ? t("config.templates.disable"): t("config.templates.enable") }
                                </button>
                            
                                <button className="dropdown-item" onClick={() => deleteForm(row.id, row.type)}>
                                    {t("config.templates.delete")}
                                </button>
                            </div>
                        </div>

                    </div>
                )
            }
        },
    ], []);


    const editTemplate = (data) => {
        console.log(data)
        setCurrentTemplate(data)
        setShowModal(true)
    }

    const changeStatus = async (id, status, type) => {
        const isConfirmed = await AlertService.warning('Aviso', '¿Estás seguro de querer cambiar el estatus del plantilla?', async () => {
            try {
                if(type === 'TXT') { 
                    await TemplatesService.toggleStatus({ templete_id: id, status: status === 1 ? 2: 1})
                } else {
                    await TemplatesService.toggleFileStatus({ templete_id: id, status: status === 1 ? 2: 1})
                }
                
                await getTemplates()
            } catch (error) {
                console.error(error);
                AlertService.error('¡Error!', 'Ocurrió un error al cambiar el estatus del plantilla, intenta nuevamente')
            }
        });

        if (isConfirmed) {
            AlertService.success('¡Éxito!', "Se cambio correctamente el estatus del plantilla");
        }
    }

    const deleteForm = async(id, type) => {
        const isConfirmed = await AlertService.warning('Borrar plantilla', '¿Estás seguro de querer borrar esta plantilla? Esta acción no se puede deshacer', async () => {
            try {
                if(type === 'TXT') {
                    await TemplatesService.toggleStatus({ templete_id: id, status: 3 })
                } else {
                    await TemplatesService.toggleFileStatus({ templete_id: id, status: 3 })
                }
                
                await getTemplates()
            } catch (error) {
                console.error(error);
                AlertService.error('¡Error!', 'Ocurrió un error al borrar la plantilla, intenta nuevamente')
            }
        });

        if (isConfirmed) {
            AlertService.success('¡Éxito!', 'Se borró la plantilla correctamente');
        }
    }
    
    const onCloseModal = async(reload: boolean) => {
        
        if(reload) {
            
            await getTemplates()    
        }

        setCurrentTemplate(null)
        setShowModal(false)
    }

    const getTemplates = async () => {
        const { data } = await call(() => TemplatesService.getTemplates(account.id));
        setTemplates(data)
    }

    useEffect(() => {
        getTemplates();
    }, [])
    

    
    return (
        <>
            <div className="card">

                <div className="card-header d-flex align-items-center">
                    <div className="me-3">
                        <h2 className="card-title h4">{t("config.templates.templates-title")}</h2>
                        <p className="small mb-0">
                            {t("config.templates.templates-p")}
                        </p>
                    </div>

                    <div className="col-sm-auto">
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={() => {
                                setShowModal(true)
                            }}
                        >
                            <i className="bi-plus-lg me-1"></i>
                            {t("config.templates.btn-create")}
                        </button>
                    </div>
                </div>

                <div className="card-body">
                    <CustomDataTable
                        columns={columns}
                        data={ templates }
                        hideAccountsFilter
                        isLoading={isRequesting}
                        filter={(row, term) => {
                            if (!term) return true;

                            return (
                                `${row.title}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.sub_account_name}`.match(new RegExp(`${term}`, 'i'))
                            )
                        }}
                    />

                </div>
            </div>

            <FormModal
                show={showModal}
                onRequestClose={onCloseModal}
                template={currentTemplate}
            />

        </>
    )
}

export default TemplatesPartial;